// 验证邮箱格式
export const validateEmail = (email) => {
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    return {
        isValid,
        message: isValid ? '' : 'Please enter a valid email address',
    };
};
// ✅ 保持现有验证函数
export const validatePassword = (password) => {
    const isValid = password.length >= 8 && password.length <= 72;
    return {
        isValid,
        message: isValid ? '' : 'Password must be between 8 and 72 characters',
    };
};
//# sourceMappingURL=authHelpers.js.map